<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <div>{{ titleKey | translate }}</div>
    <span class="ui-icon-close c-p" (click)="onCancel()"></span>
  </div>
  <div class="body">
    <div class="input-container flex-col">
      <label class="input-label">{{ 'PERSON_GROUPS.JOIN_DIALOG.CODE_LABEL' | translate }}</label>
      <input
        class="ui-input ui-input-40 w-100"
        [formControl]="codeControl"
        [placeholder]="'PERSON_GROUPS.JOIN_DIALOG.CODE_PLACEHOLDER' | translate"
        cdkFocusInitial
        uiAutofocus
      />
      @if (codeControl.hasError('required') && codeControl.touched) {
        <span class="input-error">{{ 'PERSON_GROUPS.JOIN_DIALOG.ERROR_REQUIRED' | translate }}</span>
      }
    </div>
  </div>
  <div class="footer flex-row end-center">
    <ui-button type="default" [text]="'COMMON.CANCEL' | translate" (clickAction)="onCancel()"></ui-button>
    <ui-button
      type="primary"
      [text]="submitKey | translate"
      [disabled]="codeControl.invalid || !codeControl.value?.trim()"
      (clickAction)="onContinue()"
    ></ui-button>
  </div>
</div>
